var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "15px",
    viewBox: "0 0 13 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.000000, -602.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4285791,583.642842 C39.0145173,583.642842 39.5000089,583.157359 39.5000089,582.571421 L39.5000089,577.214272 C39.5000089,576.628333 39.0145173,576.142842 38.4285791,576.142842 C37.8426409,576.142842 37.3571492,576.628333 37.3571492,577.214272 L37.3571492,582.571421 C37.3571492,583.157359 37.8426409,583.642842 38.4285791,583.642842 Z M38.4285791,590.07143 C41.9693199,590.07143 44.8571582,587.183592 44.8571582,583.642851 C44.8571582,581.608808 43.9196571,579.733806 42.2874007,578.511706 C41.8186501,578.151773 41.1406359,578.243849 40.789073,578.72097 C40.4291395,579.18972 40.5295861,579.867735 40.9983366,580.219298 C42.0865076,581.039611 42.7142985,582.286822 42.7142985,583.642851 C42.7142985,586.003345 40.789073,587.92857 38.4285791,587.92857 C36.0680852,587.92857 34.1428597,586.003345 34.1428597,583.642851 C34.1428597,582.286822 34.7706506,581.039611 35.8588216,580.219298 C36.3275721,579.867735 36.4280187,579.18972 36.0680852,578.72097 C35.7165223,578.243849 35.0468786,578.151773 34.5697575,578.511706 C32.9375011,579.733806 32,581.608808 32,583.642851 C32,587.183592 34.8878383,590.07143 38.4285791,590.07143 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignout);
export default __webpack_public_path__ + "static/media/icon-signout.40d185a52e9273e5f19abd4be4692ff2.svg";
export { ForwardRef as ReactComponent };